import React from "react";
import { urlAssetsCustom } from "utils/common";
const QuestionPage = (props) => {
  return (
    <>
      <div className="container question">
        <img
          className="img-full"
          src={urlAssetsCustom("assets/img/Title-chtg.png")}
          alt=""
        />
        <ul>
          <li>
            <span className="dot">1</span>
            <div>
              <b>
                Khách hàng còn giữ nắp kem có chứa mã số trúng thưởng mà không
                còn giữ tin nhắn thông báo trúng thưởng thì có được nhận giải
                không?
              </b>
              <p>
                Khách hàng phải giữ lại cả 2 bằng chứng (tin nhắn trúng thưởng &
                nắp kem) để được đủ điều kiện nhận giải
              </p>
            </div>
          </li>
          <li>
            <span className="dot">2</span>
            <div>
              <b>
                Hotline liên hệ nhiều lần không bắt máy nên trường hợp này đã bị
                fail. Hôm nay KH chủ động call lên tổng đài báo trúng thưởng và
                giải thích do con học online hoặc lý do nào khác nên không hay,
                KH còn giữ lại đầy đủ bằng chứng trúng thưởng thì trường hợp này
                có hỗ trợ được nữa không?
              </b>
              <p>
                Khách hàng liên hệ lại trong vòng 15 ngày kể từ khi công bố
                trúng thưởng sẽ được hỗ trợ nhận giải
              </p>
            </div>
          </li>
          <li>
            <span className="dot">3</span>
            <div>
              <b>Khách hàng hỏi bên mình là trao giải ở đâu?</b>
              <ul>
                <li>
                  Giải Voucher Du Lịch Hàn Quốc: Khách hàng trúng thưởng sẽ được
                  công ty TNHH Quốc Tế Unilever Việt Nam hoặc bên thứ ba do công
                  ty TNHH Quốc Tế Unilever VN ủy quyền sẽ liên hệ và trao đổi
                  địa điểm trao giải phù hợp. Khách hàng tự chịu chi phí đi lại
                  đến địa điểm trao giải.
                </li>
                <li>
                  Giải Chỉ vàng PNJ: Khách hàng trúng thưởng sẽ được công ty
                  TNHH Quốc Tế Unilever Việt Nam hoặc bên thứ ba do công ty TNHH
                  Quốc Tế Unilever VN ủy quyền sẽ liên hệ và trao giải tại chi
                  nhánh PNJ hoặc tại địa điểm phù hợp. Khách hàng tự chịu chi
                  phí đi lại đến địa điểm trao giải.
                </li>
                <li>
                  Giải Bộ quà giới hạn Cha Eun-Woo: Khách hàng trúng thưởng sẽ
                  được công ty TNHH Quốc Tế Unilever Việt Nam hoặc bên thứ ba do
                  công ty TNHH Quốc Tế Unilever VN ủy quyền liên hệ địa điểm
                  trao giải. Giải thưởng sẽ được chuyển thẳng đến địa điểm đã
                  được thống nhất giữa 2 bên. Chi phí vận chuyển sẽ được công ty
                  Unilever chịu.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">4</span>
            <div>
              <b>Khách hỏi bên mình là cụ thể bao lâu thì sẽ được nhận giải?</b>
              <p>Trong vòng 45 ngày kể từ ngày xác nhận nhận giải.</p>
            </div>
          </li>
          <li>
            <span className="dot">5</span>
            <div>
              <b>
                Khi không liên lạc được với số điện thoại, trường hợp đã bị đánh
                fail thì có cần gọi trong vòng bao nhiêu ngày tiếp theo không?
              </b>
              <p>
                Sau khi liên hệ 3 lần trong vòng 15 ngày mà không có người nhận
                quà hợp lệ {"("}từ chối nhận/không liên hệ được{")"} {"-->"}{" "}
                không gọi nữa & phần quà sẽ chuyển qua các đợt quay thưởng tiếp
                theo
              </p>
            </div>
          </li>

          <li>
            <span className="dot">6</span>
            <div>
              <b>Trường hợp khách hỏi nhận quà có mất phí gì không?</b>
              <p>
                Không mất phí nhận quà. Nếu có phí phát sinh liên quan đến việc
                vận chuyển quà hoặc những thủ tục khác sau khi trao quà thì KH
                tự chịu trách nhiệm
              </p>
            </div>
          </li>
          <li>
            <span className="dot">7</span>
            <div>
              <b>Khách hỏi giải quy ra tiền được không?</b>
              <p>Quà tặng là hiện vật không quy đổi thành tiền mặt</p>
            </div>
          </li>
          <li>
            <span className="dot">8</span>
            <div>
              <b>Khách hỏi chương trình kéo dài bao nhiêu lâu?</b>
              <p>
                Mời khách tìm thông tin trên trang chủ từ ngày 15/09/2024 đến
                ngày 31/12/2024
              </p>
            </div>
          </li>
          <li>
            <span className="dot">9</span>
            <div>
              <b>Khách hỏi điều kiện tham gia chương trình?</b>
              <p>
                Khách hàng của chương trình khuyến mại {"("}đối tượng hưởng
                khuyến mại{")"}: {""} Các khách hàng trên 16 tuổi, không thuộc
                ban tổ chức hoặc tham gia trực tiếp vào chương trình khuyến mãi,
                mua sản phẩm kem Cornetto có nắp cam và và tham gia chương tình
                trong khoảng thời gian từ ngày 15/9 đến 31/12 sẽ đủ điều kiện
                tham gia chương trình
              </p>
            </div>
          </li>
          <li>
            <span className="dot">10</span>
            <div>
              <b>
                Nếu khách hàng dưới 16 tuổi trúng thưởng thì có được trao thưởng
                không?
              </b>
              <p>
                Nếu KH chưa đủ tuổi tham gia chương trình thì sẽ bị xem là không
                đáp ứng điều kiện để trúng thưởng và không được nhận thưởng.
              </p>
            </div>
          </li>
          <li>
            <span className="dot">11</span>
            <div>
              <b>
                Có đóng thuế thu nhập không thường xuyên khi nhận thưởng không?
              </b>
              <ul>
                <li>
                  Đối với thuế thu nhập không thường xuyên khi nhận thưởng, công
                  ty TNHH Unilever sẽ tiến hành chi trả cho quý khách.
                </li>
                <li>
                  Đối với chi phí phát sinh khác khi nhận thưởng: Khách trúng
                  thưởng phải chịu các chi phí đi lại, ăn ở khi đến tham dự
                  chương trình khuyến mại; Người nhận thưởng phải trên 16 tuổi.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">12</span>
            <div>
              <b>Tìm mã dự thưởng ở đâu trên bao bì?</b>
              <p>
                Mã dự thưởng được in trực tiếp ở mặt dưới của nắp kem Cornetto
                có màu cam
              </p>
            </div>
          </li>
          <li>
            <span className="dot">13</span>
            <div>
              <b>Một người có thể nhận được nhiều giải thưởng hay không?</b>
              <p>
                Một (01) mã dự thưởng sau khi đăng ký thành công sẽ có cơ hội
                trúng giải thưởng:
              </p>
              <ul>
                <li>
                  Giải nhất: 02 (hai) Voucher Viettravel Du lịch Hàn Quốc - trị
                  giá 40.000.000 VND
                </li>
                <li>
                  Giải nhì: 01 (một) chỉ vàng PNJ 24K; Giải ba: 01 (một) Hộp quà
                  giới hạn Cornetto x Cha Eun-Woo{" "}
                </li>
                <li>
                  Giải khuyến khích: 01 (một) Mã nạp điện thoại 10.000 đồng.
                </li>
              </ul>
              <p>
                Chương trình giới hạn tối đa 01 số điện thoại của khách hàng
                được tham gia 5 lần trong 1 ngày và không giới hạn trong toàn bộ
                thời gian diễn ra chương trình.
              </p>
            </div>
          </li>
          <li>
            <span className="dot">14</span>
            <div>
              <b>Giải thưởng của chương trình khuyến mại?</b>
              <p>
                Khách hàng sau khi tham gia chương trình bằng cách mua sản phẩm
                Cornetto có nắp màu cam, sau đó lật nắp, quét QR và nhập mã
                trúng thưởng sẽ có cơ hội nhận được các phần quà sau:
              </p>
              <ul>
                <li>
                  Giải nhất: 02 (hai) Voucher Viettravel Du lịch Hàn Quốc - trị
                  giá 40.000.000 VND
                </li>
                <li>Giải nhì: 01 (một) chỉ vàng PNJ 24K;</li>
                <li>
                  Giải ba: 01 (một) Hộp quà giới hạn Cornetto x Cha Eun-Woo{" "}
                </li>
                <li>
                  Giải khuyến khích: 01 (một) Mã nạp điện thoại 10.000 đồng.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">15</span>
            <div>
              <b>Nếu trúng thưởng thì cách thức nhận thưởng thế nào?</b>
              <ul>
                <li>
                  Đối với thẻ điện tử nạp điện thoại 10.000đ: Khách hàng sẽ nhận
                  được 1 mã thẻ điện tử nạp điện thoại tương ứng với 1 mã dự
                  thưởng, số tiền tương ứng mã nạp điện thoại trúng thưởng sẽ
                  được nạp trực tiếp vào số điện thoại mà khách hàng đã dùng để
                  đăng nhập trang website Cornetto2024.quatangunilever.vn
                </li>
                <li>
                  Đối với Giải Du Lịch Hàn Quốc, giải 1 chỉ vàng và giải hộp quà
                  giới hạn Cha Eun-Woo : Sau khi xác định được Khách hàng trúng
                  thưởng, tổng đài tư vấn của chương trình sẽ liên hệ với khách
                  hàng để thông báo trúng thưởng và hướng dẫn các thủ tục nhận
                  giải trong vòng 15 ngày làm việc.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">16</span>
            <div>
              <b>Cần cung cấp gì để nhận thưởng?</b>
              <p>
                Bằng chứng xác định trúng thưởng hợp lệ là (1) phần nắp kem
                Cornetto của hàng hóa khuyến mại do Công Ty TNHH Quốc Tế
                Unilever Việt Nam phát hành và mặt bên dưới nắp kem đó có chứa
                mã trúng thưởng, còn nguyên vẹn, không bị rách hoặc vỡ, thiếu
                nội dung hoặc có dấu hiệu tẩy sửa, chắp vá và (2) tin nhắn SMS
                thông báo trúng thưởng từ tổng đài chương trình (Tổng đài
                UNILEVER VN) đến số điện thoại của khách hàng tham gia chương
                trình. Khi làm biên bản bàn giao cần nộp lại bằng chứng xác định
                trúng thưởng và đính kèm cùng bản chụp CCCD/CMND.
              </p>
            </div>
          </li>
          <li>
            <span className="dot">17</span>
            <div>
              <b>
                Khách hàng trúng thưởng nhưng gặp việc bận đưa giấy tờ người
                trúng cho người thân, để người thân ký biên bản nhận giùm được
                không ̣
              </b>
              <p>Không được</p>
            </div>
          </li>
          <li>
            <span className="dot">18</span>
            <div>
              <b>
                Nếu mất 1 trong 2 mã qr/mã dự thưởng thì có đc nhận giải đặc
                biệt không?
              </b>
              <p>
                Mã dự thưởng và mã QR được in cùng 1 chỗ nên không thể có trường
                hợp mất 1 trong 2
              </p>
            </div>
          </li>
          <li>
            <span className="dot">19</span>
            <div>
              <b>
                Nếu làm mất bao bì, nhưng có ảnh chụp lại thì có được hỗ trợ
                nhận thưởng không?
              </b>
              <ul>
                <li>
                  Đối với giải nhất: chuyến du lịch Hàn Quốc  và giải nhì: 1 chỉ
                  vàng PNJ cần phải gửi lại bao bì sản phẩm có mã dự thưởng thì
                  mới được nhận giải.
                </li>
                <li>
                  Đối với giải 3 phần thông tin giải thưởng đã được cập nhật ở
                  trên hệ thống, và ban tổ chức sẽ liên hệ bạn để xác nhận và
                  gửi quà.
                </li>
                <li>
                  Đối với giải khuyến khích hệ thống sẽ tự động gửi nạp tiền vào
                  số điện thoại bạn đăng ký.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">20</span>
            <div>
              <b>Thủ tục nhận thưởng?</b>
              <p>
                Thủ tục nhận thưởng : Tại thời điểm và địa điểm được hẹn trước
                với khách hàng , khi nhận thưởng, khách hàng phải xuất trình
                những giấy tờ tùy thân hợp lệ và bằng chứng xác định trúng
                thưởng cho nhân viên của bên phụ trách trao thưởng là công ty
                TNHH Quốc Tế Unilever Việt Nam hoặc bên thứ ba Công ty ủy quyền
                để tiến hành kiểm tra, đối chiếu. Khách hàng xuất trình đầy đủ
                thông tin và bằng chứng trúng thưởng:
              </p>
              <ul>
                <li>
                  Giấy tờ tùy thân (Chứng minh nhân dân hoặc Thẻ căn cước công
                  dân hoặc Hộ chiếu) còn hiệu lực sử dụng để chứng minh danh
                  tính (nhân viên trao thưởng sẽ chụp hình ảnh giấy tờ tuỳ thân
                  của khách hàng để lưu hồ sơ trúng thưởng và kê khai thuế thu
                  nhập cá nhân từ việc trúng thưởng);
                </li>
                <li>
                  Số điện thoại của khách hàng trùng khớp với số điện thoại đã
                  đăng ký trong hệ thống khi quay số;
                </li>
                <li>
                  Phần bao bì chứa Mã dự thưởng và mã QR trúng thưởng nguyên
                  vẹn, không cạo xóa, sửa, không rách rời, chắp vá, mã QR và Mã
                  dự thưởng chính xác với Mã dự thưởng đã trúng thưởng như lưu
                  trữ trong hệ thống chương trình
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">21</span>
            <div>
              <b>Giải thưởng của chương trình khuyến mại</b>
              <p>
                Khách hàng sau khi tham gia chương trình bằng cách mua sản phẩm
                Cornetto có nắp màu cam, sau đó lật nắp, quét QR và nhập mã
                trúng thưởng sẽ có cơ hội nhận được các phần quà sau:
              </p>
              <ul>
                <li>
                  Giải nhất: 02 (hai) Voucher Viettravel Du lịch Hàn Quốc - trị
                  giá 40.000.000 VND
                </li>
                <li>Giải nhì: 01 (một) chỉ vàng PNJ 24K; </li>
                <li>
                  Giải ba: 01 (một) Hộp quà giới hạn Cornetto x Cha Eun-Woo{" "}
                </li>
                <li>
                  Giải khuyến khích: 01 (một) Mã nạp điện thoại 10.000 đồng.
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className="dot">22</span>
            <div>
              <b>
                Nếu KH lỡ xóa mất tin nhắn trúng thưởng thì có được nhận giải
                không ạ?
              </b>
              <p>
                Đối với giải Nhất và giải Nhì, mất tin nhắn trúng thưởng sẽ
                không được nhận giải
              </p>
            </div>
          </li>
          <li>
            <span className="dot">23</span>
            <div>
              <b>
                Họ và tên phải trùng khớp với web nếu hotline gọi ra hỏi thông
                tin, khách đưa họ tên khác vì lý do của riêng khách thì có được
                trao giải không.
              </b>
              <p>Không được</p>
            </div>
          </li>
          <li>
            <span className="dot">24</span>
            <div>
              <b>Có cần cung cấp mã số thuế</b>
              <p>Không cần</p>
            </div>
          </li>
          <li>
            <span className="dot">25</span>
            <div>
              <b>
                KH điên tên khác với CCCD (trường hợp KH chưa có CCCD), người
                được điền CCCD là người thân
              </b>
              <p>Phải có giấy khai sinh hoặc giấy tờ chứng minh người thân</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};
export default QuestionPage;
